var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmailMainColor = function SvgGmailMainColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "m17.187 5.591-5.132 4.005-5.25-4.005v.001l.007.006v5.608l5.184 4.091 5.19-3.933z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "m18.535 4.617-1.348.974v5.773l4.24-3.256V6.146s-.514-2.801-2.892-1.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M17.187 11.364v7.487h3.25s.925-.095.992-1.15V8.108z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5221F",
    d: "m6.806 5.592-1.34-.968C3.087 3.352 2.572 6.152 2.572 6.152v1.961L6.806 11.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M2.572 8.114v9.594a1.16 1.16 0 0 0 .991 1.15h3.25L6.806 11.2z"
  })));
};
export default SvgGmailMainColor;